import './ResidencePlan.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

const ResidencePlan = () => {

  const [index, setIndex] = useState(0);

  const plans = [
    { type: '1 BED APARTMENT', beds: 1, bathrooms: 1, KITCHENETTE: 1, lounge: 1, image: './SquarePhotos/ResidencePlan/onebed.jpeg' },
    { type: '2 BED APARTMENT', beds: 2, bathrooms: 2, KITCHENETTE: 1, lounge: 1, image: './SquarePhotos/ResidencePlan/twobed.jpeg' },
    // { type: 'PENTHOUSE', beds: 3, bathrooms: 3, KITCHENETTE: 1, lounge: 1, image: './SquarePhotos/ResidencePlan/threebed.jpeg' },
  ]
  const handleLeftArrowClick = () => {
    if (index < plans.length - 1) {
      setIndex(index + 1);
    }
  };

  const handleRightArrowClick = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };


  return (
    <div>
      <div className="sqrresidence">
        <div className="sqrresi">
          <div className='sqrresidenceplan' data-aos="fade-up"
            data-aos-duration="1000">
            <div className='sqrresidenceplan-heading'>
              <h3>Residence Plan</h3>
            </div>
            <div className='sqrresidenceplan-card'>
              <div className='sqrresidenceplan-card-left'>
                <div className='sqrresidenceplan-card-left-top'>
                  <h4>{plans[index].type}</h4>
                  <div>
                    <button onClick={handleRightArrowClick} disabled={index === 0} >
                      <FontAwesomeIcon icon={faArrowLeft} className='sqrresidenceplan-card-left-top-arrows' />
                    </button>
                    <button onClick={handleLeftArrowClick} disabled={index === plans.length - 1}>
                      <FontAwesomeIcon icon={faArrowRight} className='sqrresidenceplan-card-left-top-arrows' />
                    </button>
                  </div>
                </div>
                <div className='sqrresidenceplan-card-left-mid'>
                  <div className='sqrresidenceplan-card-left-mid-content'>
                    <p>BEDROOM </p>
                    <p>{plans[index].beds}</p>
                  </div>
                  <div className='sqrresidenceplan-card-left-mid-content'>
                    <p>bathrooms</p>
                    <p>{plans[index].bathrooms}</p>
                  </div>
                  <div className='sqrresidenceplan-card-left-mid-content'>
                    <p>KITCHENETTE</p>
                    <p>{plans[index].KITCHENETTE}</p>
                  </div>
                  <div className='sqrresidenceplan-card-left-mid-content'>
                    <p>LOUNGE</p>
                    <p>{plans[index].lounge}</p>
                  </div>
                </div>
                <div className='sqrresidenceplan-card-left-bottom'>
                  <p>
                    We take pride in offering luxurious living spaces where you can truly unwind and enjoy your time.
                  </p>
                </div>
              </div>
              <div className='sqrresidenceplan-img'>
                <img src={plans[index].image} alt={plans[index].type} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResidencePlan